export default __webpack_public_path__ + "static/media/firstImageSlide.5f028eb6.png";